import {HomeScreen} from "../screens";


export default function HomeContainer(props) {
  return (
    <HomeScreen/>
  )
}
